import { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Col, Row } from 'reactstrap';
import { AssistanceRecallDTO } from "../../models/AssistanceRecall/AssistanceRecallDTO";
import CheckboxComponent from "../CheckboxComponent";
import InputComponent from '../InputComponent';
import { AssistanceService } from "../../services/AssistanceService";
import Toast from "../../helpers/Toast";
import ButtonComponent from "../ButtonComponent";
import { EditAssistanceRecallDTO } from "../../models/AssistanceRecall/EditAssistanceRecallDTO";
import { EquipmentService } from "../../services/EquipmentService";
import { EquipmentRecallDTO } from "../../models/Equipment/EquipmentRecallDTO";
import { Utilities } from "../../helpers/Utilities";
import { AssistanceDTO } from "../../models/Assistance/AssistanceDTO";
import { useAvailableModulesContext } from "../../context/AvailableModulesContext";

export type AssistanceRecallComponentProps = {
    assistance: AssistanceDTO | null;
    equipmentId: number;
    isComplete: boolean;
}

const AssistanceRecallComponent = ({ assistance, equipmentId, isComplete }: AssistanceRecallComponentProps) => {

    const intl = useIntl();
    const assistanceService = new AssistanceService();
    const equipmentService = new EquipmentService();
    const [recallFromAssistance, setRecallFromAssistance] = useState<AssistanceRecallDTO>();
    const [recallFromEquipment, setRecallFromEquipment] = useState<EquipmentRecallDTO>();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isEditButtonLoading, setIsEditButtonLoading] = useState<boolean>(false);

    const { availableModules } = useAvailableModulesContext();

    const GetRecallByAssistanceId = async () => {
        setIsLoading(true);
        var response = await assistanceService.GetAssistanceRecall(assistance?.id ?? 0);
        if (response.success === false || response.obj == null) {
            setIsLoading(false);
            Toast.Show("error", response.message);
            return;
        }
        setRecallFromAssistance(response.obj);   
        setIsLoading(false);
    };

    const GetRecallByEquipmentId = async () => {
        setIsLoading(true);
        var response = await equipmentService.RecallDetailsFromEquipment(equipmentId);
        if (response.success === false || response.obj == null) {
            setIsLoading(false);
            Toast.Show("error", response.message);
            return;
        }
        setRecallFromEquipment(response.obj);
        setIsLoading(false);
    };

    useEffect(() => {
        if (assistance?.id && equipmentId) {
            GetRecallByAssistanceId()
            GetRecallByEquipmentId()
        }
    }, [assistance?.id, equipmentId])

    const editAssitanceRecall = async () => {
        setIsEditButtonLoading(true);

        const updatedAssistanceRecall: EditAssistanceRecallDTO = {
            docType: assistance?.erpDocType ?? "",
            serie: assistance?.erpSerie ?? "",
            number: assistance?.erpNumDoc ?? 0,
            assistanceId: assistance?.id ?? 0,
            recallDescription: recallFromAssistance?.recallDescription ?? null,
            recallStartDate: recallFromAssistance?.recallStartDate ?? null,
            recallEndDate: recallFromAssistance?.recallEndDate ?? null,
            recallIncludesSecurity: recallFromAssistance?.recallIncludesSecurity ?? false,
            recallIncludesRisk: recallFromAssistance?.recallIncludesRisk ?? false,
            recallIncludesDefect: recallFromAssistance?.recallIncludesDefect ?? false,
        };

        const response = await assistanceService.EditAssistanceRecall(updatedAssistanceRecall);
        setIsEditButtonLoading(false);

        if (response.success !== true) {
            Toast.Show("error", response.message);
            return;
        }
        Toast.Show("success", response.message);
    };

    useEffect(() => {

    }, [availableModules]);

    return (
        <div>
            { }
            <Row
                style={{
                    margin: "0px",
                    marginTop: "10px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <label style={{ margin: "0px", padding: "13px", fontSize: "15px" }}>
                    <b>
                        <FormattedMessage id="Screens.Recall.Equipment.Title" />
                    </b>
                </label>
            </Row>

            <Row
                style={{
                    margin: "0px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <InputComponent
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ width: "100%" }}
                    type="date"
                    value={recallFromEquipment?.recallStartDate == null ? "" : Utilities.formatDateYYYYMMDD(new Date(recallFromEquipment.recallStartDate))}
                    label={intl.formatMessage({ id: "Screens.Equipment.RecallStartDate" })}
                    readOnly={true}
                />

                <InputComponent
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ width: "100%" }}
                    type="date"
                    value={recallFromEquipment?.recallEndDate == null ? "" : Utilities.formatDateYYYYMMDD(new Date(recallFromEquipment.recallEndDate))}
                    label={intl.formatMessage({ id: "Screens.Equipment.RecallEndDate" })}
                    readOnly={true}
                />
            </Row>

            <Row
                style={{
                    margin: "0px",
                    marginTop: "10px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                    <CheckboxComponent
                        checked={recallFromEquipment?.recallIncludesSecurity}
                        disabled={true}
                        label={intl.formatMessage({ id: "Screens.Equipment.RecallIncludesSecurity" })}
                    />
                </Col>

                <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                    <CheckboxComponent
                        checked={recallFromEquipment?.recallIncludesRisk}
                        disabled={true}
                        label={intl.formatMessage({ id: "Screens.Equipment.RecallIncludesRisk" })}
                    />
                </Col>

                <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                    <CheckboxComponent
                        checked={recallFromEquipment?.recallIncludesDefect}
                        disabled={true}
                        label={intl.formatMessage({ id: "Screens.Equipment.RecallIncludesDefect" })}
                    />
                </Col>

                <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={recallFromEquipment?.recallDescription}
                    label={intl.formatMessage({ id: "Screens.Equipment.RecallDescription" })}
                    readOnly={true}
                />
            </Row>

            <Row style={{ margin: "1rem 0px" }}>
                <Row style={{ marginTop: '10px' }}>

                    <label style={{ margin: "0px", padding: "13px", fontSize: "15px" }}>
                        <b>
                            <FormattedMessage id="Screens.Recall.Assistance.Title" />
                        </b>
                    </label>

                    <Row
                        style={{
                            margin: "0px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        <InputComponent
                            xl={4}
                            lg={4}
                            md={4}
                            sm={4}
                            xs={12}
                            style={{ width: "100%" }}
                            type="date"
                            value={recallFromAssistance?.recallStartDate
                                ? (recallFromAssistance.recallStartDate instanceof Date
                                    ? recallFromAssistance.recallStartDate.toISOString().split('T')[0]
                                    : Utilities.formatDateYYYYMMDD(new Date(recallFromAssistance.recallStartDate))
                                )
                                : ''
                            }
                            label={intl.formatMessage({ id: "Screens.Equipment.RecallStartDate" })}
                            readOnly={false}
                            onChange={(recallStartDate: Date) => {
                                setRecallFromAssistance({
                                    ...recallFromAssistance!,
                                    recallStartDate: recallStartDate ? new Date(recallStartDate) : null
                                });
                            }}
                            showLoadingSkeleton={isLoading || isEditButtonLoading}
                        />

                        <InputComponent
                            xl={4}
                            lg={4}
                            md={4}
                            sm={4}
                            xs={12}
                            style={{ width: "100%" }}
                            type="date"
                            value={recallFromAssistance?.recallEndDate
                                ? (recallFromAssistance.recallEndDate instanceof Date
                                    ? recallFromAssistance.recallEndDate.toISOString().split('T')[0]
                                    : Utilities.formatDateYYYYMMDD(new Date(recallFromAssistance.recallEndDate))
                                )
                                : ''
                            }
                            label={intl.formatMessage({ id: "Screens.Equipment.RecallEndDate" })}
                            readOnly={false}
                            onChange={(recallEndDate: Date) => {
                                setRecallFromAssistance({
                                    ...recallFromAssistance!,
                                    recallEndDate: recallEndDate ? new Date(recallEndDate) : null
                                });
                            }}
                            showLoadingSkeleton={isLoading || isEditButtonLoading}
                        />
                    </Row>


                    <Row
                        style={{
                            margin: "0px",
                            marginTop: "10px",
                            padding: "0px",
                            alignItems: "flex-end",
                            alignContent: "flex-end",
                        }}
                    >
                        <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                            <CheckboxComponent
                                checked={recallFromAssistance?.recallIncludesSecurity ?? false}
                                disabled={isLoading || isEditButtonLoading}
                                onChange={() => {
                                    setRecallFromAssistance({ ...recallFromAssistance!, recallIncludesSecurity: !recallFromAssistance?.recallIncludesSecurity });
                                }}
                                label={intl.formatMessage({ id: "Screens.Assistance.ConsiderSecurityInRecall" })}
                            />
                        </Col>

                        <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                            <CheckboxComponent
                                checked={recallFromAssistance?.recallIncludesRisk ?? false}
                                disabled={isLoading || isEditButtonLoading}
                                onChange={() => {
                                    setRecallFromAssistance({ ...recallFromAssistance!, recallIncludesRisk: !recallFromAssistance?.recallIncludesRisk });
                                }}
                                label={intl.formatMessage({ id: "Screens.Assistance.ConsiderRiskInRecall" })}
                            />
                        </Col>

                        <Col xl={4} lg={4} md={12} sm={12} xs={12}>
                            <CheckboxComponent
                                checked={recallFromAssistance?.recallIncludesDefect ?? false}
                                disabled={isLoading || isEditButtonLoading}
                                onChange={() => {
                                    setRecallFromAssistance({ ...recallFromAssistance!, recallIncludesDefect: !recallFromAssistance?.recallIncludesDefect });
                                }}
                                label={intl.formatMessage({ id: "Screens.Assistance.ConsiderDefectInRecall" })}
                            />
                        </Col>
                    </Row>
                </Row>

                <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={recallFromAssistance?.recallDescription}
                    label={intl.formatMessage({ id: "Screens.Assistance.RecallDescription" })}
                    readOnly={isLoading || isEditButtonLoading}
                    onChange={(recallDescription: string) => {
                        setRecallFromAssistance({ ...recallFromAssistance!, recallDescription: recallDescription });
                    }}
                    showLoadingSkeleton={isLoading || isEditButtonLoading}
                />
            </Row>

            <Row style={{ margin: "0px", padding: "0px", justifyContent: "end" }}>
                <Col xl={3} lg={3} md={3} sm={12} xs={12}>
                    <ButtonComponent
                        style={{ width: "100%", marginTop: "10px" }}
                        text={intl.formatMessage({ id: "AssistanceEditA.Save" })}
                        onClick={() => editAssitanceRecall()}
                        disabled={isLoading || isComplete || isEditButtonLoading}
                    />
                </Col>
            </Row>

        </div>
    )
}

export default AssistanceRecallComponent